import API from '../utils/api';
import { AGENT_SERVICE_ENDPOINT_URL } from '../constants/defaultValues';

const FAVORITES_URL = 'cashier-favorite-events';

const getFavoriteEvents = async () => {
    try {
        const res = await API.get(`${AGENT_SERVICE_ENDPOINT_URL}/${FAVORITES_URL}`);
        return res.data;
    } catch (error) {
        console.error(error);
    }
};

const addEventToFavorites = async id => {
    try {
        const res = await API.post(`${AGENT_SERVICE_ENDPOINT_URL}/${FAVORITES_URL}?eventId=${id}`);
        return res.data;
    } catch (error) {
        console.error(error);
    }
};

const removeEventFromFavorites = async id => {
    try {
        return await API.post(
            `${AGENT_SERVICE_ENDPOINT_URL}/${FAVORITES_URL}?eventId=${id}&actionType=delete`
        );
    } catch (error) {
        console.error(error);
    }
};

const modifyFavoriteLeague = async (payload, params) => {
    try {
        const res = await API.post(
            `${AGENT_SERVICE_ENDPOINT_URL}/cashier-favorite-leagues`,
            payload,
            { params }
        );

        return res.data;
    } catch (error) {
        console.error(error);

        return { info: { success: false } };
    }
};

const getFavoriteLeagues = async params => {
    try {
        const res = await API.get(`${AGENT_SERVICE_ENDPOINT_URL}/cashier-favorite-leagues`, {
            params,
        });

        return res.data;
    } catch (error) {
        console.error(error);

        return { info: { success: false } };
    }
};

const FavoritesService = {
    getFavoriteEvents,
    addEventToFavorites,
    removeEventFromFavorites,
    modifyFavoriteLeague,
    getFavoriteLeagues,
};

export default FavoritesService;
